import { render, staticRenderFns } from "./AccountIndex.vue?vue&type=template&id=0fa8c925"
import script from "./AccountIndex.vue?vue&type=script&lang=js"
export * from "./AccountIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports